module.exports = __webpack_public_path__ + "app/img/Xena_french.44ccf54e.jpg";